import React from 'react';
import { motion } from 'framer-motion';
import { assets } from '../lib/assets';

const occasions = [
  { key: 'birthday', title: 'Birthdays', copy: 'A candle melts. A tree remembers.', img: assets.birthday, span: 'md:col-span-4 md:row-span-2' },
  { key: 'anniversary', title: 'Anniversaries', copy: 'Count years in rings, not numbers.', img: assets.couple, span: 'md:col-span-4' },
  { key: 'baby', title: 'Baby birth', copy: 'Grown together, leaf by leaf.', img: assets.baby, span: 'md:col-span-4' },
  { key: 'memorial', title: 'In memory', copy: 'A quiet place that keeps giving.', img: assets.memorial, span: 'md:col-span-4' },
  { key: 'wedding', title: 'Weddings', copy: 'Rooted in two families at once.', img: assets.wedding, span: 'md:col-span-4' },
  { key: 'corporate', title: 'Corporate gifting', copy: 'Gifts your team will actually talk about.', img: assets.corporate, span: 'md:col-span-4' },
];

export default function Occasions({ onGift }) {
  return (
    <section id="occasions" className="bg-brand-bg py-28 md:py-36" data-testid="occasions-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div className="max-w-xl">
            <p className="text-brand-gold tracking-[0.25em] uppercase text-xs mb-5 font-medium">Occasions</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink leading-[1.05] tracking-tight font-light">
              For every moment <em className="text-brand-forest">worth keeping.</em>
            </h2>
          </div>
          <p className="md:max-w-sm text-brand-ink2 leading-relaxed">
            Some moments deserve more than wrapping paper. Choose the one you're honouring.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {occasions.map((o, i) => (
            <motion.button
              key={o.key}
              onClick={onGift}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.8, delay: i * 0.08 }}
              whileHover={{ y: -4 }}
              className="relative group overflow-hidden rounded-3xl h-[320px] text-left"
              data-testid={`occasion-card-${o.key}`}
            >
              <img src={o.img} alt={o.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/85 via-brand-ink/20 to-transparent" />
              <div className="absolute inset-0 p-7 md:p-8 flex flex-col justify-end">
                <div className="font-serif text-2xl md:text-3xl text-brand-bg mb-1">{o.title}</div>
                <div className="text-brand-bg/80 text-sm italic font-serif">{o.copy}</div>
              </div>
              <div className="absolute top-5 right-5 w-10 h-10 rounded-full bg-brand-bg/20 backdrop-blur-sm border border-brand-bg/30 flex items-center justify-center text-brand-bg opacity-0 group-hover:opacity-100 transition-all duration-500">
                →
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
